// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1VIcy","colCheckbox":"styles_colCheckbox__321Fq"};